<template>
	<div id="NotFound">
		<v-container>
      <div class="title">A página que você procura não existe :(</div>
      <v-btn to="/editor">Voltar</v-btn>
		</v-container>
	</div>
</template>

<script>
export default {
    name: 'NotFound',
}
</script>
